var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7198 14.9833C10.5541 14.9833 10.4156 15.1218 10.4156 15.2875V33.3126C10.4156 33.4783 10.5541 33.6168 10.7198 33.6168H37.2303C37.3738 33.6168 37.5345 33.5009 37.5345 33.2624V15.2875C37.5345 15.1218 37.396 14.9833 37.2303 14.9833H10.7198ZM9.01562 15.2875C9.01562 14.3486 9.78091 13.5833 10.7198 13.5833H37.2303C38.1692 13.5833 38.9345 14.3486 38.9345 15.2875V33.2624C38.9345 34.229 38.1914 35.0168 37.2303 35.0168H10.7198C9.78091 35.0168 9.01562 34.2515 9.01562 33.3126V15.2875Z",
    fill: "#9BE7C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5165 16.0053C38.7301 16.3276 38.642 16.7619 38.3198 16.9755L25.0661 25.7611C25.0657 25.7614 25.0653 25.7617 25.0649 25.7619C24.3786 26.2189 23.5712 26.2189 22.8848 25.7619C22.8844 25.7617 22.8841 25.7614 22.8837 25.7611L9.62997 16.9755C9.30774 16.7619 9.21967 16.3276 9.43327 16.0053C9.64687 15.6831 10.0813 15.595 10.4035 15.8086L23.6602 24.5963C23.877 24.7408 24.0728 24.7408 24.2895 24.5963L24.2911 24.5953L37.5463 15.8086C37.8685 15.595 38.3029 15.6831 38.5165 16.0053Z",
    fill: "#9BE7C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6d6b0a38640ba1a0948948945b06b7f8.svg";
export { ForwardRef as ReactComponent };